import styles from './SkeletonText.module.scss';

interface SkeletonTextProps {
  /** Number of skeleton text lines
   * @default 3
   */
  lines?: number;
}

export function SkeletonText({ lines = 3 }: SkeletonTextProps) {
  return (
    <>
      {[...new Array(lines)].map((index) => (
        <div key={index} className={styles.SkeletonText}>
          &nbsp;
        </div>
      ))}
    </>
  );
}
